import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { NavigationProgressService } from '@services';

@Component({
  selector: 'app-navigation-progress',
  imports: [TranslatePipe],
  template: `
    @if (navigationProgress.visible()) {
      <div
        class="progress-track"
        role="progressbar"
        [attr.aria-label]="'WEB_NAVIGATION_LOADING_PAGE' | translate"
      >
        <div class="progress-runner"></div>
      </div>
    }
  `,
  styles: `
    .progress-track {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      z-index: 9999;
      overflow: hidden;
      background: transparent;
    }

    .progress-runner {
      height: 100%;
      width: 40%;
      background: var(--bs-primary);
      border-radius: 0 3px 3px 0;
      animation: navigation-progress-slide 1.2s ease-in-out infinite;
    }

    @media (prefers-reduced-motion: reduce) {
      .progress-runner {
        animation: none;
        width: 100%;
        opacity: 0.6;
      }
    }

    @keyframes navigation-progress-slide {
      0% {
        transform: translateX(-100%);
      }

      100% {
        transform: translateX(250%);
      }
    }
  `,
})
export class NavigationProgressComponent {
  navigationProgress = inject(NavigationProgressService);
}
